export const translations = {
  en: {
    // General
    appName: 'Inone',
    loading: 'Loading…',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    view: 'View',
    back: 'Back to Restaurants',
    confirm_delete: 'Remove this payment record?',
    noData: 'No data',
    search: 'Search by name or address…',
    notFound: 'No restaurants found',
    page: 'Page',
    of: 'of',
    prev: '← Prev',
    next: 'Next →',

    // Auth
    signIn: 'Sign In',
    signingIn: 'Signing in…',
    username: 'Username',
    password: 'Password',
    adminPortal: 'Admin Portal — Sign in to continue',
    signOut: 'Sign out',
    signedInAs: 'Signed in as',
    setupHint: 'First time? Run POST /api/auth/setup to create your admin account.',

    // Nav
    restaurants: 'Restaurants',
    auditLogs: 'Audit Logs',

    // Dashboard
    totalRestaurants: 'Total Restaurants',
    paidThisMonth: 'Paid',
    unpaidOverdue: 'Unpaid / Overdue',

    // Table headers
    restaurant: 'Restaurant',
    plan: 'Plan',
    phone: 'Phone',
    phoneNumber: 'Phone Number',
    address: 'Address',
    status: 'Status',
    lastPayment: 'Last Payment',
    actions: 'Actions',

    // Status
    paid: 'Paid',
    unpaid: 'Unpaid',
    overdue: 'Not paid',

    // Payment modal
    recordPayment: 'Record Payment',
    month: 'Month',
    year: 'Year',
    amount: 'Amount (UZS)',
    amountPlaceholder: 'e.g. 500000',
    paymentMethod: 'Payment Method',
    cash: 'Cash',
    card: 'Card',
    transfer: 'Bank Transfer',
    invoiceNumber: 'Invoice Number (optional)',
    invoicePlaceholder: 'INV-2024-001',
    notes: 'Notes (optional)',
    notesPlaceholder: 'Any remarks…',
    saving: 'Saving…',
    pay: '+ Pay',

    // Restaurant detail
    totalPayments: 'Total Payments',
    totalCollected: 'Total Collected',
    memberSince: 'Member Since',
    paymentHistory: 'Payment History',
    calendarView: 'Calendar View',
    recordedBy: 'Recorded By',
    date: 'Date',
    noPayments: 'No payments recorded yet',
    recordPaymentBtn: '+ Record Payment',

    // Calendar
    paid_cal: 'Paid',
    overdue_cal: 'Overdue',
    noData_cal: 'No Data',
    invoiceLabel: 'Invoice',

    // Audit logs
    auditTitle: 'Audit Logs',
    auditSubtitle: 'Every admin action is recorded here',
    totalEvents: 'total events',
    timestamp: 'Timestamp',
    admin: 'Admin',
    action: 'Action',
    details: 'Details',
    noActivity: 'No activity yet',
    paymentAdded: 'Payment Added',
    paymentDeleted: 'Payment Deleted',
    paymentUpdated: 'Payment Updated',
    adminCreated: 'Admin Created',
    adminUpdated: 'Admin Updated',
    adminDeleted: 'Admin Deleted',
    totalAmount: 'Package Price (UZS)',
    paidAmount: 'Amount Paid (UZS)',
    remainingAmount: 'Remaining',
    paymentStatus: 'Status',
    partial: 'Partial',
    partial_cal: 'Partial',
    outstanding: 'Outstanding',
    totalOutstanding: 'Total Outstanding',
    bulkPayment: 'Bulk Payment',
    singlePayment: 'Single Month',
    fromMonth: 'From Month',
    toMonth: 'To Month',
    bulkSuccess: 'created',
    bulkSkipped: 'skipped (already exist)',
    adminManagement: 'Admin Management',
    addAdmin: 'Add Admin',
    editAdmin: 'Edit Admin',
    editRequest: 'Edit Request',
    role: 'Role',
    roleSuperadmin: 'Superadmin',
    roleAdmin: 'Admin',
    newPassword: 'New Password (leave blank to keep)',
    confirmDeleteAdmin: 'Delete this admin?',
    noAdmins: 'No admins found',
    collected: 'Collected',
    totalBilled: 'Total Billed',
    partialMonths: 'Partial',
    paidMonths: 'Paid',
    unpaidMonths: 'Unpaid',

    // Months
    months: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    monthsShort: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],

    // Theme
    lightMode: 'Light',
    darkMode: 'Dark',
    rowsPerPage: 'Rows per page',
    // Partner
    partnerPortal: 'Partner Portal',
    myRestaurants: 'My Restaurants',
    requests: 'Requests',
    newRequest: 'New Request',
    createRestaurant: 'Create Restaurant',
    editRestaurant: 'Edit Restaurant',
    deactivate: 'Deactivate',
    restaurantName: 'Restaurant Name',
    initialMessage: 'Initial Message (optional)',
    initialMessagePlaceholder: 'Add a note for the admin…',
    deactivateWarning: 'Requesting deactivation of {name}. Once approved, it will be unlinked from your account.',
    newMessages: 'new',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    feedback: 'Feedback',
    noFeedback: 'No messages yet',
    submitRequest: 'Submit Request',
    cancelRequest: 'Cancel Request',
    myRequests: 'My Requests',
    noRequests: 'No requests yet',
    allRequests: 'All Requests',
    reviewRequest: 'Review Request',
    approve: 'Approve',
    reject: 'Reject',
    adminFeedback: 'Feedback (optional)',
    requestedBy: 'Requested by',
    reviewedAt: 'Reviewed at',
    reviewedBy: 'Reviewed by',
    companyName: 'Company Name',
    partnerPhone: 'Partner Phone',
    assignRestaurants: 'Assign Restaurants',
    assignedRestaurants: 'Assigned Restaurants',
    noAssignedRestaurants: 'No restaurants assigned yet',
    partner: 'Partner',
    rolePartner: 'Partner',
    markAsRead: 'Mark as read',
    // Plans
    planManagement: 'Plan Management',
    createPlan: 'Create Plan',
    editPlan: 'Edit Plan',
    planName: 'Plan Name',
    planPrice: 'Price (UZS)',
    planActive: 'Active',
    noPlans: 'No plans yet',

    UPDATE_RESTAURANT: 'Restaurant Updated',
    allPartners: 'All Partners',
    bulkHint: 'Same amount & method applied to each month. Already-recorded months are skipped.',
    noPartner: '— No partner',
    allStatuses: 'All Statuses',
    selectOption: '— Select —',
    nextMonthExpected: 'Expected Next Month',
    editRestaurantInfo: 'Edit Restaurant',
    CREATE_PLAN: 'Plan Created',
    UPDATE_PLAN: 'Plan Updated',
    DELETE_PLAN: 'Plan Deleted',
    planAutoFill: 'Price auto-filled from plan',
    selectPlan: 'Select Plan',
    noPlanSelected: 'No plan (manual)',
    reportTitle: 'Payment Report',
    REQUEST_APPROVED: 'Request Approved',
    REQUEST_REJECTED: 'Request Rejected',
    ASSIGN_RESTAURANTS: 'Restaurants Assigned',
  },

  ru: {
    appName: 'Inone',
    loading: 'Загрузка…',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    view: 'Просмотр',
    back: 'Назад к ресторанам',
    confirm_delete: 'Удалить эту запись об оплате?',
    noData: 'Нет данных',
    search: 'Поиск по названию или адресу…',
    notFound: 'Рестораны не найдены',
    page: 'Страница',
    of: 'из',
    prev: '← Назад',
    next: 'Вперёд →',

    signIn: 'Войти',
    signingIn: 'Вход…',
    username: 'Имя пользователя',
    password: 'Пароль',
    adminPortal: 'Панель администратора — войдите для продолжения',
    signOut: 'Выйти',
    signedInAs: 'Вы вошли как',
    setupHint: 'Первый раз? Выполните POST /api/auth/setup для создания аккаунта.',

    restaurants: 'Рестораны',
    auditLogs: 'Журнал действий',

    totalRestaurants: 'Всего ресторанов',
    paidThisMonth: 'Оплатили',
    unpaidOverdue: 'Не оплатили / Просрочено',

    restaurant: 'Ресторан',
    plan: 'Тариф',
    phone: 'Телефон',
    phoneNumber: 'Номер телефона',
    address: 'Адрес',
    status: 'Статус',
    lastPayment: 'Последний платёж',
    actions: 'Действия',

    paid: 'Оплачено',
    unpaid: 'Не оплачено',
    overdue: 'Не оплачено',

    recordPayment: 'Записать оплату',
    month: 'Месяц',
    year: 'Год',
    amount: 'Сумма (UZS)',
    amountPlaceholder: 'напр. 500000',
    paymentMethod: 'Способ оплаты',
    cash: 'Наличные',
    card: 'Карта',
    transfer: 'Банковский перевод',
    invoiceNumber: 'Номер счёта (необязательно)',
    invoicePlaceholder: 'СЧ-2024-001',
    notes: 'Примечания (необязательно)',
    notesPlaceholder: 'Любые замечания…',
    saving: 'Сохранение…',
    pay: '+ Оплата',

    totalPayments: 'Всего платежей',
    totalCollected: 'Собрано всего',
    memberSince: 'Клиент с',
    paymentHistory: 'История платежей',
    calendarView: 'Календарь',
    recordedBy: 'Записал',
    date: 'Дата',
    noPayments: 'Платежи ещё не записаны',
    recordPaymentBtn: '+ Записать оплату',

    paid_cal: 'Оплачено',
    overdue_cal: 'Просрочено',
    noData_cal: 'Нет данных',
    invoiceLabel: 'Счёт',

    auditTitle: 'Журнал действий',
    auditSubtitle: 'Все действия администраторов записаны здесь',
    totalEvents: 'всего событий',
    timestamp: 'Время',
    admin: 'Администратор',
    action: 'Действие',
    details: 'Детали',
    noActivity: 'Активности пока нет',
    paymentAdded: 'Платёж добавлен',
    paymentDeleted: 'Платёж удалён',
    paymentUpdated: 'Платёж обновлён',
    adminCreated: 'Администратор создан',
    adminUpdated: 'Администратор обновлён',
    adminDeleted: 'Администратор удалён',
    totalAmount: 'Сумма пакета (UZS)',
    paidAmount: 'Оплачено (UZS)',
    remainingAmount: 'Остаток',
    paymentStatus: 'Статус',
    partial: 'Частично',
    partial_cal: 'Частично',
    outstanding: 'Задолженность',
    totalOutstanding: 'Общая задолженность',
    bulkPayment: 'Пакетный платёж',
    singlePayment: 'Один месяц',
    fromMonth: 'С месяца',
    toMonth: 'По месяц',
    bulkSuccess: 'создано',
    bulkSkipped: 'пропущено (уже есть)',
    adminManagement: 'Управление администраторами',
    addAdmin: 'Добавить администратора',
    editAdmin: 'Редактировать',
    editRequest: 'Редактировать заявку',
    role: 'Роль',
    roleSuperadmin: 'Суперадмин',
    roleAdmin: 'Администратор',
    newPassword: 'Новый пароль (оставьте пустым для сохранения)',
    confirmDeleteAdmin: 'Удалить этого администратора?',
    noAdmins: 'Администраторы не найдены',
    collected: 'Собрано',
    totalBilled: 'Выставлено',
    partialMonths: 'Частично',
    paidMonths: 'Оплачено',
    unpaidMonths: 'Не оплачено',

    months: ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
    monthsShort: ['Янв','Фев','Мар','Апр','Май','Июн','Июл','Авг','Сен','Окт','Ноя','Дек'],

    lightMode: 'Светлая',
    darkMode: 'Тёмная',
    rowsPerPage: 'Строк на странице',
    // Partner
    partnerPortal: 'Портал партнёра',
    myRestaurants: 'Мои рестораны',
    requests: 'Заявки',
    newRequest: 'Новая заявка',
    requestType: 'Тип заявки',
    createRestaurant: 'Создать ресторан',
    editRestaurant: 'Изменить ресторан',
    requestStatus: 'Статус',
    pending: 'На рассмотрении',
    approved: 'Одобрено',
    rejected: 'Отклонено',
    deactivate: 'Деактивировать',
    restaurantName: 'Название ресторана',
    initialMessage: 'Начальное сообщение (необязательно)',
    initialMessagePlaceholder: 'Добавьте примечание для администратора…',
    deactivateWarning: 'Запрос на деактивацию {name}. После подтверждения он будет отвязан от вашего аккаунта.',
    newMessages: 'новых',
    feedback: 'Комментарий администратора',
    noFeedback: 'Комментарий не предоставлен',
    submitRequest: 'Отправить заявку',
    cancelRequest: 'Отменить заявку',
    requestSubmitted: 'Заявка успешно отправлена',
    requestCancelled: 'Заявка отменена',
    myRequests: 'Мои заявки',
    noRequests: 'Заявок пока нет',
    pendingRequests: 'Ожидающие заявки',
    allRequests: 'Все заявки',
    reviewRequest: 'Рассмотреть заявку',
    approve: 'Одобрить',
    reject: 'Отклонить',
    adminFeedback: 'Комментарий (необязательно)',
    requestedBy: 'Запрошено',
    requestedAt: 'Дата запроса',
    reviewedAt: 'Дата рассмотрения',
    reviewedBy: 'Рассмотрено',
    companyName: 'Название компании',
    partnerPhone: 'Телефон партнёра',
    assignRestaurants: 'Назначить рестораны',
    assignedRestaurants: 'Назначенные рестораны',
    noAssignedRestaurants: 'Рестораны не назначены',
    partner: 'Партнёр',
    rolePartner: 'Партнёр',
    requestDetails: 'Детали заявки',
    submittedRequests: 'Отправлено',
    notifications: 'Уведомления',
    markAsRead: 'Отметить как прочитанное',
    // Plans
    planManagement: 'Управление тарифами',
    createPlan: 'Создать тариф',
    editPlan: 'Редактировать тариф',
    planName: 'Название тарифа',
    planPrice: 'Цена (UZS)',
    planActive: 'Активен',
    noPlans: 'Тарифов пока нет',

    UPDATE_RESTAURANT: 'Ресторан обновлён',
    allPartners: 'Все партнёры',
    bulkHint: 'Одинаковые сумма и метод применяются к каждому месяцу. Уже записанные месяцы пропускаются.',
    noPartner: '— Без партнёра',
    allStatuses: 'Все статусы',
    selectOption: '— Выбрать —',
    nextMonthExpected: 'Ожидается в следующем месяце',
    editRestaurantInfo: 'Редактировать ресторан',
    CREATE_PLAN: 'Тариф создан',
    UPDATE_PLAN: 'Тариф обновлён',
    DELETE_PLAN: 'Тариф удалён',
    planAutoFill: 'Цена заполнена из тарифа',
    selectPlan: 'Выбрать тариф',
    noPlanSelected: 'Без тарифа (вручную)',
    newNotification: 'Статус заявки обновлён',
    deactivateRestaurant: 'Деактивировать ресторан',
    requestThread: 'Сообщения',
    sendMessage: 'Отправить',
    typeMessage: 'Введите сообщение…',
    noMessages: 'Сообщений нет. Начните переписку.',
    youLabel: 'Вы',
    adminLabel: 'Администратор',
    requestApproved: 'Заявка одобрена',
    requestRejected: 'Заявка отклонена',
    reportTitle: 'Отчёт по платежам',
    REQUEST_APPROVED: 'Заявка одобрена',
    REQUEST_REJECTED: 'Заявка отклонена',
    ASSIGN_RESTAURANTS: 'Рестораны назначены',
  },

  uz: {
    appName: 'Inone',
    loading: 'Yuklanmoqda…',
    save: 'Saqlash',
    cancel: 'Bekor qilish',
    delete: "O'chirish",
    view: "Ko'rish",
    back: 'Restoranlarga qaytish',
    confirm_delete: "Bu to'lov yozuvini o'chirmoqchimisiz?",
    noData: "Ma'lumot yo'q",
    search: "Nomi yoki manzil bo'yicha qidirish\u2026",
    notFound: 'Restoranlar topilmadi',
    page: 'Sahifa',
    of: '/',
    prev: '← Oldingi',
    next: 'Keyingi →',

    signIn: 'Kirish',
    signingIn: 'Kirilmoqda…',
    username: 'Foydalanuvchi nomi',
    password: 'Parol',
    adminPortal: 'Admin paneli — davom etish uchun kiring',
    signOut: 'Chiqish',
    signedInAs: 'Siz kirgansiz',
    setupHint: 'Birinchi marta? Admin akkaunt yaratish uchun POST /api/auth/setup ga murojaat qiling.',

    restaurants: 'Restoranlar',
    auditLogs: 'Amallar jurnali',

    totalRestaurants: 'Jami restoranlar',
    paidThisMonth: "To'lov qildi",
    unpaidOverdue: "To'lamadi / Muddati o'tgan",

    restaurant: 'Restoran',
    plan: 'Tarif',
    phone: 'Telefon',
    phoneNumber: 'Telefon raqami',
    address: 'Manzil',
    status: 'Holat',
    lastPayment: "Oxirgi to'lov",
    actions: 'Amallar',

    paid: "To'langan",
    unpaid: "To'lanmagan",
    overdue: "To'lanmagan",

    recordPayment: "To'lovni qayd etish",
    month: 'Oy',
    year: 'Yil',
    amount: 'Miqdor (UZS)',
    amountPlaceholder: 'mas. 500000',
    paymentMethod: "To'lov usuli",
    cash: 'Naqd',
    card: 'Karta',
    transfer: "Bank o'tkazmasi",
    invoiceNumber: 'Hisob-faktura raqami (ixtiyoriy)',
    invoicePlaceholder: 'HF-2024-001',
    notes: 'Izohlar (ixtiyoriy)',
    notesPlaceholder: 'Har qanday izoh…',
    saving: 'Saqlanmoqda…',
    pay: "+ To'lov",

    totalPayments: "Jami to'lovlar",
    totalCollected: "Jami yig'ildi",
    memberSince: "Mijoz bo'lgandan",
    paymentHistory: "To'lovlar tarixi",
    calendarView: 'Kalendar',
    recordedBy: 'Qayd qildi',
    date: 'Sana',
    noPayments: "Hali to'lovlar qayd etilmagan",
    recordPaymentBtn: "+ To'lovni qayd etish",

    paid_cal: "To'langan",
    overdue_cal: "Muddati o'tgan",
    noData_cal: "Ma'lumot yo'q",
    invoiceLabel: 'Hisob',

    auditTitle: 'Amallar jurnali',
    auditSubtitle: 'Barcha admin amallari bu yerda qayd etilgan',
    totalEvents: 'jami hodisa',
    timestamp: 'Vaqt',
    admin: 'Admin',
    action: 'Amal',
    details: 'Tafsilotlar',
    noActivity: "Hali faollik yo'q",
    paymentAdded: "To'lov qo'shildi",
    paymentDeleted: "To'lov o'chirildi",
    paymentUpdated: "To'lov yangilandi",
    adminCreated: 'Admin yaratildi',
    adminUpdated: 'Admin yangilandi',
    adminDeleted: "Admin o'chirildi",
    totalAmount: 'Paket narxi (UZS)',
    paidAmount: "To'langan (UZS)",
    remainingAmount: 'Qoldiq',
    paymentStatus: 'Holat',
    partial: 'Qisman',
    partial_cal: 'Qisman',
    outstanding: 'Qarz',
    totalOutstanding: 'Umumiy qarz',
    bulkPayment: "Ommaviy to'lov",
    singlePayment: 'Bitta oy',
    fromMonth: 'Dan oy',
    toMonth: 'Gacha oy',
    bulkSuccess: 'yaratildi',
    bulkSkipped: "o'tkazib yuborildi (allaqachon bor)",
    adminManagement: 'Admin boshqaruvi',
    addAdmin: 'Admin qoshish',
    editAdmin: 'Tahrirlash',
    editRequest: "So'rovni tahrirlash",
    role: 'Rol',
    roleSuperadmin: 'Superadmin',
    roleAdmin: 'Admin',
    newPassword: "Yangi parol (saqlash uchun bo'sh qoldiring)",
    confirmDeleteAdmin: 'Bu adminni ochirilsinmi?',
    noAdmins: 'Adminlar topilmadi',
    collected: "Yig'ildi",
    totalBilled: 'Hisoblangan',
    partialMonths: 'Qisman',
    paidMonths: "To'langan",
    unpaidMonths: "To'lanmagan",

    months: ['Yanvar','Fevral','Mart','Aprel','May','Iyun','Iyul','Avgust','Sentabr','Oktabr','Noyabr','Dekabr'],
    monthsShort: ['Yan','Fev','Mar','Apr','May','Iyn','Iyl','Avg','Sen','Okt','Noy','Dek'],

    lightMode: 'Yorqin',
    darkMode: "Qo'ng'ir",
    rowsPerPage: 'Qatorlar soni',
    // Partner
    partnerPortal: 'Hamkor portali',
    myRestaurants: 'Mening restoranlarim',
    requests: "So'rovlar",
    newRequest: "Yangi so'rov",
    createRestaurant: 'Restoran yaratish',
    editRestaurant: 'Restoranni tahrirlash',
    deactivate: 'Deaktivatsiya',
    restaurantName: 'Restoran nomi',
    initialMessage: "Boshlang'ich xabar (ixtiyoriy)",
    initialMessagePlaceholder: "Admin uchun izoh qo'shing…",
    deactivateWarning: "{name} ni deaktivatsiya qilish so'rovi. Tasdiqlangandan so'ng, u hisobingizdan ajratiladi.",
    newMessages: 'yangi',
    pending: 'Kutilmoqda',
    approved: 'Tasdiqlandi',
    rejected: 'Rad etildi',
    feedback: 'Admin izohi',
    noFeedback: "Xabarlar yo'q",
    submitRequest: "So'rov yuborish",
    cancelRequest: "So'rovni bekor qilish",
    myRequests: "Mening so'rovlarim",
    noRequests: "So'rovlar yo'q",
    allRequests: "Barcha so'rovlar",
    reviewRequest: "So'rovni ko'rib chiqish",
    approve: 'Tasdiqlash',
    reject: 'Rad etish',
    adminFeedback: 'Izoh (ixtiyoriy)',
    requestedBy: 'Yuboruvchi',
    reviewedAt: "Ko'rib chiqilgan sana",
    reviewedBy: "Ko'rib chiquvchi",
    companyName: 'Kompaniya nomi',
    partnerPhone: 'Hamkor telefoni',
    assignRestaurants: 'Restoranlarni biriktirish',
    assignedRestaurants: 'Biriktirilgan restoranlar',
    noAssignedRestaurants: 'Restoranlar biriktirilmagan',
    partner: 'Hamkor',
    rolePartner: 'Hamkor',
    markAsRead: "O'qildi deb belgilash",
    // Plans
    planManagement: 'Tariflar boshqaruvi',
    createPlan: 'Tarif yaratish',
    editPlan: 'Tarifni tahrirlash',
    planName: 'Tarif nomi',
    planPrice: 'Narx (UZS)',
    planActive: 'Faol',
    noPlans: 'Tariflar mavjud emas',

    UPDATE_RESTAURANT: 'Restoran yangilandi',
    allPartners: 'Barcha hamkorlar',
    bulkHint: 'Bir xil summa va usul har oyga qo\'llaniladi. Allaqachon yozilgan oylar o\'tkazib yuboriladi.',
    noPartner: '— Hamkorsiz',
    allStatuses: 'Barcha holatlar',
    selectOption: '— Tanlang —',
    nextMonthExpected: 'Keyingi oyda kutilmoqda',
    editRestaurantInfo: 'Restoranni tahrirlash',
    CREATE_PLAN: 'Tarif yaratildi',
    UPDATE_PLAN: 'Tarif yangilandi',
    DELETE_PLAN: "Tarif o'chirildi",
    planAutoFill: 'Narx tarifdan avtomatik kiritildi',
    selectPlan: 'Tarifni tanlang',
    noPlanSelected: "Tarifsiz (qo'lda)",
    reportTitle: "To'lov hisoboti",
    REQUEST_APPROVED: "So'rov tasdiqlandi",
    REQUEST_REJECTED: "So'rov rad etildi",
    ASSIGN_RESTAURANTS: 'Restoranlar biriktirildi',
  }
};
